import { Amplify } from 'aws-amplify';

// Configuration loaded from environment variables or remote config
// In production, config.json will be loaded via loadRemoteConfig()
const getConfig = () => {
  // Check if config is available in window (loaded from config.json)
  if (typeof window !== 'undefined' && (window as any).APP_CONFIG) {
    return (window as any).APP_CONFIG;
  }

  // Fallback to environment variables (for local development)
  return {
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001',
    cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    cognitoUserPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID || '',
    cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    graphqlApiUrl: import.meta.env.VITE_GRAPHQL_API_URL || '',
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  };
};

// Load config from config.json for deployed environment
export async function loadRemoteConfig() {
  try {
    const response = await fetch('/config.json');
    if (response.ok) {
      const config = await response.json();
      (window as any).APP_CONFIG = config;
      return config;
    }
  } catch (err) {
    console.log('No remote config found, using build-time config');
  }
  return null;
}

export const configureAmplify = () => {
  const config = getConfig();

  console.log('[Amplify] Configuring with:', {
    cognitoUserPoolId: config.cognitoUserPoolId,
    cognitoUserPoolClientId: config.cognitoUserPoolClientId?.substring(0, 10) + '...',
    graphqlApiUrl: config.graphqlApiUrl,
    region: config.region,
  });

  if (!config.graphqlApiUrl) {
    console.error('[Amplify] WARNING: graphqlApiUrl is missing!');
  }

  const amplifyConfig = {
    Auth: {
      Cognito: {
        userPoolId: config.cognitoUserPoolId,
        userPoolClientId: config.cognitoUserPoolClientId,
        signUpVerificationMethod: 'code' as const,
        loginWith: {
          email: true,
          oauth: {
            domain: config.cognitoDomain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code' as const,
          },
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: config.graphqlApiUrl,
        region: config.region,
        defaultAuthMode: 'userPool' as const,
      },
    },
  };

  console.log('[Amplify] Full config:', JSON.stringify(amplifyConfig, null, 2));

  Amplify.configure(amplifyConfig);

  console.log('[Amplify] Configuration complete');
};

export const appConfig = getConfig();
